import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {PartnerService} from '../service/partner.service';
import {RealEstateAgentService} from '../service/real-estate-agent.service';

@Injectable()
export class RealEstateAgentItemsResolver implements Resolve<any> {
  constructor(private realEstateAgentService: RealEstateAgentService) {
  }

  resolve(route: ActivatedRouteSnapshot,
          state: RouterStateSnapshot): Observable<any> {

    return this.realEstateAgentService.getRealEstateAgentItems();

  }
}
